import RouteNames from "@/entities/RouteNames";
import BreadcrumbsTitles from "@/entities/BreadcrumbsTitles";
import { getChildRoutes } from "@/helpers/routes/getChildRoutes";
import RouteSectionsPrefixes from "@/entities/RouteSectionsPrefixes";
import RouteWrapper from "@/components/common/RouteWrapper.vue";
import { GetRelativeRoutes } from "@/entities/GetChildRoutes";
import Roles from "@/entities/Roles";

const Projects = () =>
  import("@/views/manage/ProjectsNew.vue").then((m) => m.default);
const AllClients = () =>
  import("@/views/manage/projectDetails/AllClients.vue").then((m) => m.default);
const AllVisits = () =>
  import("@/views/manage/projectDetails/AllVisits.vue").then((m) => m.default);
const AllEmptyVisits = () =>
  import(
    "@/views/manage/projectDetails/Visits/EmptyVisits/AllEmptyVisitsMain.vue"
  ).then((m) => m.default);
const AllEmptyVisitTab = () =>
  import(
    "@/views/manage/projectDetails/Visits/EmptyVisits/AllEmptyVisitTab.vue"
  ).then((m) => m.default);
const ActiveClients = () =>
  import("@/views/manage/projectDetails/Clients/ActiveClients.vue").then(
    (m) => m.default
  );
const ColsedClients = () =>
  import("@/views/manage/projectDetails/Clients/ClosedClients.vue").then(
    (m) => m.default
  );
const DraftClients = () =>
  import("@/views/manage/projectDetails/Clients/DraftClients.vue").then(
    (m) => m.default
  );
const OfferedVisits = () =>
  import(
    "@/views/manage/projectDetails/Visits/EmptyVisits/OfferedVisits.vue"
  ).then((m) => m.default);
const AcceptedVisits = () =>
  import(
    "@/views/manage/projectDetails/Visits/AssignedVisits/AcceptedVisists.vue"
  ).then((m) => m.default);
const CompletedVisits = () =>
  import(
    "@/views/manage/projectDetails/Visits/CompletedVisits/CompletedVisits.vue"
  ).then((m) => m.default);
const RejectedVisits = () =>
  import(
    "@/views/manage/projectDetails/Visits/EmptyVisits/DeclinedVisits.vue"
  ).then((m) => m.default);
const DraftVisits = () =>
  import(
    "@/views/manage/projectDetails/Visits/EmptyVisits/DraftVisits.vue"
  ).then((m) => m.default);
const Details = () =>
  import("@/views/manage/projectDetails/DetailsNew.vue").then((m) => m.default);
const Activities = () =>
  import("@/views/manage/projectDetails/ActivitiesNew.vue").then(
    (m) => m.default
  );
const EmptyActivities = () =>
  import("@/views/manage/projectDetails/EmptyActivities.vue").then(
    (m) => m.default
  );
const ProjectDocuments = () =>
  import("@/views/manage/projectDetails/DocumentsNew.vue").then(
    (m) => m.default
  );
const ProjectContractors = () =>
  import("@/views/manage/projectDetails/ContractorsNew.vue").then(
    (m) => m.default
  );
const ProjectRequests = () =>
  import("@/views/manage/projectDetails/RequestsNew.vue").then(
    (m) => m.default
  );
const ProjectGroups = () =>
  import("@/views/manage/projectDetails/GroupsNew.vue").then((m) => m.default);
const Project = () =>
  import("@/views/manage/ProjectNew.vue").then((m) => m.default);
const AdminTimeTrackerTab = () =>
  import("@/components/projects/timeTracker/AdminTimeTrackerTab.vue").then(
    (m) => m.default
  );
const ProjectClient = () =>
  import("@/views/manage/projectDetails/ClientsNew.vue");
const ProjectCarePlan = () =>
  import("@/views/manage/projectDetails/CarePlanNew.vue");
const Notes = () =>
  import("@/views/manage/projectDetails/Notes.vue").then((m) => m.default);

const getMainAllVisitsRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "/clients_visit/all-visits",
    name: RouteNames.ALL_VISITS,
    component: AllVisits,
    meta: {
      title: "All Visits",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        title: BreadcrumbsTitles.ALL_VISITS,
        isStyled: true,
      },
    },
    redirect: {
      name: RouteNames.ALL_EMPTY_VISITS, // Redirect to Empty Visits tab initially
    },
    children: [
      {
        path: "/clients_visit/all-visits/open-visits",
        name: RouteNames.ALL_EMPTY_VISITS,
        component: AllEmptyVisits,
        meta: {
          title: "Open Visits",
          roles: [Roles.ADMIN, Roles.MANAGER],
          breadcrumb: {
            isStyled: true,
          },
        },
        redirect: {
          name: RouteNames.ALL_EMPTY_VISITS_TAB, // Redirect to default tab
        },
        children: [
          {
            path: "/clients_visit/all-visits/open-visits/all-open-visits",
            name: RouteNames.ALL_EMPTY_VISITS_TAB,
            component: AllEmptyVisitTab,
            meta: {
              title: "All open Visits",
              roles: [Roles.ADMIN, Roles.MANAGER],
              breadcrumb: {
                title: BreadcrumbsTitles.ALL_EMPTY_VISITS_TAB,
                isStyled: true,
              },
            },
          },
          {
            path: "/clients_visit/all-visits/open-visits/draft-visits",
            name: RouteNames.ALL_DRAFT_VISITS,
            component: DraftVisits,
            meta: {
              title: "Draft Visits",
              roles: [Roles.ADMIN, Roles.MANAGER],
              breadcrumb: {
                title: BreadcrumbsTitles.ALL_DRAFT_VISITS,
                isStyled: true,
              },
            },
          },
          {
            path: "/clients_visit/all-visits/open-visits/offered-visits",
            name: RouteNames.PENDING_VISITS,
            component: OfferedVisits,
            meta: {
              title: "Offered Visits",
              roles: [Roles.ADMIN, Roles.MANAGER],
              breadcrumb: {
                title: BreadcrumbsTitles.PENDING_VISITS,
                isStyled: true,
              },
            },
          },
          {
            path: "/clients_visit/all-visits/open-visits/declined-visits",
            name: RouteNames.REJECTED_VISITS,
            component: RejectedVisits,
            meta: {
              title: "Declined Visits",
              roles: [Roles.ADMIN, Roles.MANAGER],
              breadcrumb: {
                title: BreadcrumbsTitles.REJECTED_VISITS,
                isStyled: true,
              },
            },
          },
        ],
      },
      {
        path: "/clients_visit/all-visits/accepted-visits",
        name: RouteNames.ACCEPTED_VISITS,
        component: AcceptedVisits,
        meta: {
          title: "Accepted Visits",
          roles: [Roles.ADMIN, Roles.MANAGER],
          breadcrumb: {
            title: BreadcrumbsTitles.ACCEPTED_VISITS,
            isStyled: true,
          },
        },
      },
      {
        path: "/clients_visit/all-visits/completed-visits",
        name: RouteNames.COMPLETED_VISITS,
        component: CompletedVisits,
        meta: {
          title: "Completed Visits",
          roles: [Roles.ADMIN, Roles.MANAGER],
          breadcrumb: {
            title: BreadcrumbsTitles.COMPLETED_VISITS,
            isStyled: true,
          },
        },
      },
    ],
  },
]);

const getMainAllClientsTabsRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "/clients_visit/all-clients",
    name: RouteNames.ALL_CLIENTS,
    component: AllClients,
    meta: {
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        title: BreadcrumbsTitles.ALL_CLIENTS,
        isStyled: true,
      },
    },
    redirect: {
      name: RouteNames.ALL_ACTIVE_CLIENTS,
    },
    children: [
      {
        path: "/clients_visit/all-clients/active-profiles",
        name: RouteNames.ALL_ACTIVE_CLIENTS,
        component: ActiveClients,
        meta: {
          title: "Active Clients",
          roles: [Roles.ADMIN, Roles.MANAGER],
          breadcrumb: {
            title: BreadcrumbsTitles.ALL_ACTIVE_CLIENTS,
            isStyled: true,
          },
        },
      },
      {
        path: "/clients_visit/all-clients/draft-profiles",
        name: RouteNames.ALL_DRAFT_CLIENTS,
        component: DraftClients,
        meta: {
          title: "Draft Clients",
          roles: [Roles.ADMIN, Roles.MANAGER],
          breadcrumb: {
            title: BreadcrumbsTitles.ALL_DRAFT_CLIENTS,
            isStyled: true,
          },
        },
      },
      {
        path: "/clients_visit/all-clients/closed-profiles",
        name: RouteNames.ALL_COMPLETED_CLIENTS,
        component: ColsedClients,
        meta: {
          title: "Completed Clients",
          roles: [Roles.ADMIN, Roles.MANAGER],
          breadcrumb: {
            title: BreadcrumbsTitles.ALL_COMPLETED_CLIENTS,
            isStyled: true,
          },
        },
      },
    ],
  },
]);

const getMainTwoTabRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "",
    component: Projects,
    props: true,
    meta: {
      title: "",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        title: BreadcrumbsTitles.MANAGE_MAIN_CLIENTS,
        routeName: RouteNames.MANAGE_PROJECTS,
        prefix: RouteSectionsPrefixes.PROJECT_ALL_VISITS,
        isStyled: true,
      },
    },
    children: [
      ...getMainAllVisitsRoutes({}),
      ...getMainAllClientsTabsRoutes({}),
    ],
  },
]);

const getProjectsRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "/clients_visit",
    component: RouteWrapper,
    meta: {
      title: "",
      breadcrumb: {
        title: BreadcrumbsTitles.MANAGE_COMPANIES,
        routeName: RouteNames.MANAGE_PROJECTS,
        prefix: RouteSectionsPrefixes.PROJECT_ALL_VISITS,
        copyLink: false,
        isStyled: true,
      },
    },
  },
]);

const getProjectsPrivatePageRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "/:id",
    component: Details,
    props: true,
    meta: {
      title: "Details",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        routeName: RouteNames.PROJECT_DETAILS,
        isStyled: true,
      },
    },
  },
]);

const getProjectPrivatePageTabsRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "details",
    name: RouteNames.PROJECT_DETAILS,
    component: Details,
    meta: {
      title: "Project Details",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
  {
    path: "activities",
    name: RouteNames.PROJECT_ACTIVITY,
    component: Activities,
    meta: {
      title: "Project Visits",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
  {
    path: "open-visits",
    name: RouteNames.PROJECT_ACTIVITY_EMPTY,
    component: EmptyActivities,
    meta: {
      title: "Project Visits",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
  {
    path: "documents",
    name: RouteNames.PROJECT_DOCUMENTS,
    component: ProjectDocuments,
    meta: {
      title: "Project Documents",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
  {
    path: "contractors",
    name: RouteNames.PROJECT_CONTRACTORS,
    component: ProjectContractors,
    meta: {
      title: "Project Contractors",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
  {
    path: "requests",
    name: RouteNames.PROJECT_REQUESTS,
    component: ProjectRequests,
    meta: {
      title: "Project Requests",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
  {
    path: "groups",
    name: RouteNames.PROJECT_GROUPS,
    component: ProjectGroups,
    meta: {
      title: "Project Groups",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
  {
    path: "timetracked",
    name: RouteNames.PROJECT_TIME_TRACKED,
    component: AdminTimeTrackerTab,
    meta: {
      title: "Times Tracked for Project",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
  {
    path: "notes",
    name: RouteNames.PROJECT_NOTES,
    component: Notes,
    meta: {
      title: "Notes",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
  {
    path: "client",
    name: RouteNames.PROJECT_CLIENT,
    component: ProjectClient,
    meta: {
      title: "Project Client",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
  {
    path: "care-plan",
    name: RouteNames.PROJECT_CARE_PLAN,
    component: ProjectCarePlan,
    meta: {
      title: "Care Plan",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        isStyled: true,
      },
    },
  },
]);

const getProjectRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "",
    name: RouteNames.MANAGE_PROJECTS,
    component: Projects,
    meta: {
      title: "Projects",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        isStyled: true,
      },
    },
    children: [
      {
        path: "",
        name: RouteNames.MANAGE_PROJECTS,
        redirect: {
          name: RouteNames.ALL_VISITS,
        },
      },
    ],
  },
  {
    path: ":id",
    component: Project,
    props: true,
    meta: {
      title: "Project",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        title: BreadcrumbsTitles.PROJECT_DETAILS,
        routeName: RouteNames.PROJECT_DETAILS,
        isStyled: true,
      },
    },
    children: [...getProjectPrivatePageTabsRoutes({})],
  },
]);

const getProjectPrivatePageRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "",
    component: RouteWrapper,
    meta: {
      title: "Projects",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        title: BreadcrumbsTitles.MANAGE_MAIN_CLIENTS,
        routeName: RouteNames.MANAGE_PROJECTS,
        isStyled: true,
      },
    },
    children: [...getProjectRoutes({})],
  },
]);
export {
  getProjectsRoutes,
  getProjectRoutes,
  getProjectPrivatePageTabsRoutes,
  getMainAllClientsTabsRoutes,
  getProjectPrivatePageRoutes,
  getProjectsPrivatePageRoutes,
  getMainAllVisitsRoutes,
  getMainTwoTabRoutes,
};
